module.exports = __webpack_public_path__ + "static/media/zoom+.5e294ae5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Editor/components/common/img/zoom+.svg
// module id = 908
// module chunks = 0